module.exports = __webpack_public_path__ + "img/744.8593fe23.jpg";